function dataHook(...hooks) {
  return hooks.map((hook) => {
    if (Array.isArray(hook)) {
      return hook.map((h) => `[data-hook~="${h}"]`).join("");
    }
    if (hook === "") {
      return `[data-hook="${hook}"]`;
    }
    return `[data-hook~="${hook}"]`;
  }).join(" ");
}
export {
  dataHook
};
//# sourceMappingURL=dataHook.js.map
